/* Núcleo compartilhado dos benefícios do carrinho.
   Lê o JSON de snippets/cart-rewards.liquid e expõe em window.LofRewards, para
   o cart-progress.js e o cart-gift.js não duplicarem regra nem discordarem. */
(function () {
  'use strict';

  var dados = null;
  try { dados = JSON.parse(document.querySelector('[data-cart-rewards]').textContent); }
  catch (e) { return; }
  if (!dados) return;

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  /* Uma oferta só vale se o produto for único no conjunto todo (níveis por
     valor + combos por produto): duas ofertas no mesmo produto disputariam o
     mesmo desconto, e o Shopify aplica só um desconto de produto por linha.
     Os níveis são conferidos primeiro, então em caso de choque quem sai é o
     combo. */
  var vistos = {};

  function unico(oferta, rotuloDoTipo) {
    if (vistos[oferta.variante]) {
      console.warn('[LOF] ' + rotuloDoTipo + ' ignorado: o produto já está em outra oferta de brinde. ' +
                   'Cada brinde precisa de um produto diferente.');
      return false;
    }
    vistos[oferta.variante] = true;
    return true;
  }

  var BRINDES = (dados.brindes || []).filter(function (b) {
    return unico(b, 'Nível ' + b.nivel);
  }).sort(function (a, b) { return a.valor - b.valor; });

  /* Id estável por oferta: é a chave das marcações de sessão e do casamento
     entre linha do carrinho e oferta. */
  BRINDES.forEach(function (b) { b.id = 'n' + b.nivel; });

  /* Combos "compre X, ganhe Y": não dependem do valor do pedido, então não
     entram nos marcos da barra — têm mensagem própria no carrinho. */
  var COMBOS = (dados.combos || []).filter(function (c) {
    return c.gatilhos && c.gatilhos.length && unico(c, 'Combo ' + c.id);
  });

  function ehBrinde(item) { return !!(item.properties && item.properties._brinde); }

  function itensPagos(carrinho) {
    return carrinho.items.filter(function (i) { return !ehBrinde(i); });
  }

  /* As linhas de brinde não contam para o próprio mínimo: senão um brinde
     ajudaria a liberar o próximo nível e o carrinho entraria em cascata. */
  function valorBase(carrinho) {
    return itensPagos(carrinho).reduce(function (s, i) { return s + i.final_line_price; }, 0);
  }

  /* Combo liberado: o cliente comprou algum dos produtos do gatilho. Só conta
     item pago — um brinde não pode disparar outro brinde. */
  function comboLiberado(carrinho, combo) {
    return itensPagos(carrinho).some(function (i) {
      return combo.gatilhos.some(function (g) { return String(g) === String(i.product_id); });
    });
  }

  /* O cliente já está comprando a própria variante do brinde. */
  function temPago(carrinho, varianteId) {
    return itensPagos(carrinho).some(function (i) {
      return String(i.variant_id) === String(varianteId);
    });
  }

  /* Oferta desligada nesta visita pelo cart-gift.js: o desconto do Shopify não
     zerou o brinde. Fica aqui porque a barra também precisa saber. */
  function bloqueada(oferta) {
    try { return sessionStorage.getItem('lof-brinde-sem-desconto-' + oferta.id) === '1'; }
    catch (e) { return false; }
  }

  /* O Shopify aplica UM desconto automático de produto por pedido. Então no
     máximo um combo vale por vez — o primeiro configurado ganha. */
  function combosAtivos(carrinho) {
    return COMBOS.filter(function (c) {
      return !bloqueada(c) && comboLiberado(carrinho, c);
    }).slice(0, 1);
  }

  /* Pela mesma regra, com um combo ativo os níveis por valor não teriam como
     zerar: saem de cena para a barra não prometer o que o checkout não entrega.
     Voltam sozinhos quando o produto do gatilho deixa o carrinho. */
  function niveisAtivos(carrinho) {
    return combosAtivos(carrinho).length ? [] : BRINDES;
  }

  /* Marcos da barra: frete + brindes por valor em jogo. Os de mesmo valor viram
     um só, senão o trecho entre eles teria largura zero. */
  function marcosDe(carrinho) {
    var todos = niveisAtivos(carrinho).slice();
    if (dados.frete) todos.push(dados.frete);

    var mapa = {};
    todos.forEach(function (m) {
      if (!mapa[m.valor]) mapa[m.valor] = { valor: m.valor, itens: [] };
      mapa[m.valor].itens.push(m);
    });
    return Object.keys(mapa).map(function (k) { return mapa[k]; })
      .sort(function (a, b) { return a.valor - b.valor; });
  }

  /* Limite de unidades por pedido (usado pelo cart-limit.js). Só vale com pelo
     menos um produto na lista e um máximo maior que zero. */
  var LIMITE = null;
  if (dados.limite && dados.limite.variantes && dados.limite.qtd > 0) {
    if (Object.keys(dados.limite.variantes).length) LIMITE = dados.limite;
  }

  /* Depois de mexer no carrinho por conta própria: a página /cart vem do
     servidor, então recarrega; no drawer, reabrimos para o theme.js repintar —
     e só com ele já aberto, para não abrir o carrinho sem o cliente pedir. */
  function rerenderizar() {
    if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
    var d = document.querySelector('[data-cart-drawer]');
    if (d && !d.classList.contains('hidden')) {
      var t = document.querySelector('[data-cart-toggle]');
      if (t) t.click();
    }
  }

  window.LofRewards = {
    brindes: BRINDES,
    combos: COMBOS,
    /* Tem algum benefício configurado? (a barra usa para decidir se existe) */
    temBeneficios: !!(BRINDES.length || COMBOS.length || dados.frete),
    textos: dados.textos || {},
    frete: dados.frete || null,
    ehBrinde: ehBrinde,
    valorBase: valorBase,
    comboLiberado: comboLiberado,
    combosAtivos: combosAtivos,
    niveisAtivos: niveisAtivos,
    marcosDe: marcosDe,
    temPago: temPago,
    limite: LIMITE,
    rerenderizar: rerenderizar,
    fmt: function (c) { return money.format((c || 0) / 100); },
    esc: function (s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
                      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
    carrinho: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
  };
})();
